import { useGoalById } from 'features/goals';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { ID } from 'shared/types/id';
import { getCompletionPercentage } from 'shared/utils/get-completion-percentage';
import { getGoalCompletion } from 'shared/utils/get-goal-completion';

export type GoalCompletionProgress = {
  completed: number;
  end: number;
  percentage: number;
};

export const useGoalCompletion = (id?: ID): GoalCompletionProgress => {
  const goal = useGoalById(id);
  const taskCounts = useTaskCounts();

  return useMemo<GoalCompletionProgress>(() => {
    if (!goal) {
      return { completed: 0, end: 0, percentage: 0 };
    }

    const completion = getGoalCompletion(goal, {
      goalProgressCounts: taskCounts?.byGoalProgress,
    });

    return {
      completed: completion.current,
      // an unmeasurable target has no count to chart
      end: Number.isFinite(completion.end) ? completion.end : 0,
      percentage: getCompletionPercentage(completion),
    };
  }, [goal, taskCounts?.byGoalProgress]);
};
